export default {
  root: {
    marginBottom: 0,
    marginTop: 0,
  },
};
